import React from 'react'
const GoogleLoader = () => {
    return (
        <div className="google-loader">
            <div className="blue ball"></div>
            <div className="red ball"></div>
            <div className="yellow ball"></div>
            <div className="green ball"></div>
        </div>
    )
}
export default GoogleLoader;